<template>
    <vConsumptionLineComponent :postList="postList" v-if="flag"></vConsumptionLineComponent>
</template>
<script>
import vConsumptionLineComponent from '../../listComponent/basicdata/performance/consumptionLineComponent.vue';
export default {
    name: 'consumption_line',
    components: {
        vConsumptionLineComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>